/* eslint-disable react/jsx-filename-extension */
import React, { useState } from 'react';
import useStoredState from '../../hooks/useStoredState';
import Aside from './Aside.js';
import Main from './Main.js';

const COLLAPSED_KEY = '@Jurisnet:menuCollapsed';
const isBoolean = (value) => typeof value === 'boolean';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function Layout(props) {
  const [collapsed, setCollapsed] = useStoredState(COLLAPSED_KEY, false, isBoolean);
  const [toggled, setToggled] = useState(false);

  const token = localStorage.getItem('@Jurisnet:token');

  return (
    <div className="app" style={{ display: 'flex' }}>
      {token ? (
        <Aside
          collapsed={collapsed}
          toggled={toggled}
          handleToggleSidebar={setToggled}
          handleCollapsedChange={setCollapsed}
        />
      ) : null}
      <Main
        toggled={toggled}
        collapsed={collapsed}
        handleToggleSidebar={setToggled}
        handleCollapsedChange={setCollapsed}
        props={props}
      />
    </div>
  );
}

export default Layout;
